import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { Add } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"
import SearchFactor from "components/search-factor"
import "./style.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

function SelectFactorView({ openDialog, addView, factors }) {
  function openSelectView(ev) {
    ev.currentTarget.blur()
    window.analytics.track("analyze-trends-select-view-factor-selection")
    openDialog({
      title: "Select View",
      content: <SearchFactor
        factors={factors}
        selectItem={addView}
      />,
    })
  }
  return <Tooltip enterDelay={TOOLTIP_ENTER_DELAY_MS} title="Add View">
    <IconButton
      onClick={openSelectView}
      className="components_select-factor-view"
      size="large"
    >
      <Add />
    </IconButton>
  </Tooltip>
}

SelectFactorView.propTypes = {
  openDialog: PropTypes.func.isRequired,
  addView: PropTypes.func.isRequired,
  factors: PropTypes.array.isRequired,
}

export default SelectFactorView
